exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-company-container[data-v-eb8f6504] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.selected-company-label[data-v-eb8f6504] {\n  color: #fff;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-weight: 500;\n  cursor: pointer;\n}", ""]);

// exports
